{
  "version": 1,
  "note": "CP21 placeholder art - flat, LEGO-brick-ish colored SVG shapes (Brief SS9/SS10 confirms LEGO-style art direction; the seed-locked stacked-prompt art pipeline drops real assets in later). To swap art: replace the referenced SVG file's content (same key/filename) or point `file` at a new file under assets/sprites/ - src/assets/loadAssets.ts resolves whatever `file` names via a glob, so no game code changes are required either way.",
  "sprites": {
    "tree.corrupted": {
      "file": "tree-corrupted.svg",
      "width": 64,
      "height": 128,
      "description": "Beornings side - dark, Sauron-corrupted tree, not yet chopped."
    },
    "tree.stump": {
      "file": "tree-stump.svg",
      "width": 64,
      "height": 48,
      "description": "Beornings side - stump left behind after a tree is chopped."
    },
    "plot.empty": {
      "file": "plot-empty.svg",
      "width": 64,
      "height": 32,
      "description": "Lothwen side - empty planting plot, not yet planted."
    },
    "tree.planted": {
      "file": "tree-planted.svg",
      "width": 64,
      "height": 112,
      "description": "Lothwen side - new tree/flowers after planting (single stage, no upgrade tiers per Brief SS9)."
    },
    "player.male": {
      "file": "player-male.svg",
      "width": 40,
      "height": 72,
      "description": "Beornings player character (chops)."
    },
    "player.female": {
      "file": "player-female.svg",
      "width": 40,
      "height": 72,
      "description": "Lothwen player character (plants)."
    },
    "minasTirith.bg": {
      "file": "minas-tirith-bg.svg",
      "width": 480,
      "height": 380,
      "description": "Single simplified Minas Tirith background illustration at world position 0 (Brief SS9 - not a multi-tile city footprint)."
    },
    "parallax.sky": {
      "file": "parallax-sky.svg",
      "width": 1024,
      "height": 540,
      "description": "Farthest parallax layer."
    },
    "parallax.hills": {
      "file": "parallax-hills.svg",
      "width": 1024,
      "height": 220,
      "description": "Mid parallax layer."
    },
    "particle.leaf": {
      "file": "particle-leaf.svg",
      "width": 12,
      "height": 12,
      "description": "Planting-growth particle burst (Lothwen)."
    },
    "particle.chip": {
      "file": "particle-chip.svg",
      "width": 10,
      "height": 10,
      "description": "Chop-hit wood-chip particle burst (Beornings)."
    }
  }
}
